var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"reportTable",staticClass:"tabulator-css",class:_vm.vizCount > 1 ? 'multi-viz' : (_vm.$store.state.bannerStatus ? 'r1c2true' : 'r1c2false')})])}
var staticRenderFns = []

export { render, staticRenderFns }